import { createSlice } from '@reduxjs/toolkit'
import { lazy } from 'react'
import constantRoutes from '@/router'
import { Navigate } from 'react-router-dom'
import { getAllowedMenuKeys } from '@/constants/menuPermission'

function filterAsyncRoutes(routes) {
  const res = []
  // 遍历得到的路由转换为前端router结构
  routes.forEach(route => {
    const tmp = {
      path: route.path,
      menuPath: route?.menuPath,
      element: route.component === 'Layout' ? null : route.component,
      redirect: route.redirect || undefined,
      title: route.title,
      hidden: !!Number(route.hidden),
      children: route.children || undefined
    }
    if (route.icon) {
      tmp.icon = route.icon
    }
    if (tmp.children && tmp.children.length) {
      tmp.children = route.redirect
        ? [
          { index: true, element: <Navigate to={route.redirect} replace /> }
        ].concat(filterAsyncRoutes(tmp.children))
        : filterAsyncRoutes(tmp.children)
    }
    res.push(tmp)
  })
  return res
}
const permissionSlice = createSlice({
  name: 'permission',
  initialState: {
    // routers默认为静态路由，之后拼接上服务器返回动态路由
    routes: constantRoutes,
    permissionRoutes: []
  },
  reducers: {
    setRoutes(state, action) {
      state.routes = constantRoutes.map(item => {
        if (item.path === '/') {
          return {
            ...item,
            children: item.children.concat(action.payload.routes)
          }
        }
        return item
      })
    },
    setPermissionRoutes(state, action) {
      state.permissionRoutes = action.payload.routes
    }
  }
})

export const { setRoutes, setPermissionRoutes } = permissionSlice.actions
export const generateRoutes = (payload, allowedMenus?: string[]) => dispatch => {
  let accessedRoutes = filterAsyncRoutes(payload)

  if (allowedMenus && allowedMenus.length > 0) {
    const allowedKeys = getAllowedMenuKeys(allowedMenus)
    if (allowedKeys) {
      accessedRoutes = accessedRoutes.filter(
        route => allowedKeys.has('/' + route.path)
      )
    }
  }

  dispatch(setRoutes({ routes: accessedRoutes }))
  dispatch(setPermissionRoutes({ routes: accessedRoutes }))
  return accessedRoutes
}

export default permissionSlice
